import script from "./FundraisingFlagCard.vue?vue&type=script&setup=true&lang=js"
export * from "./FundraisingFlagCard.vue?vue&type=script&setup=true&lang=js"

import "./FundraisingFlagCard.vue?vue&type=style&index=0&id=21203cf7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21203cf7"]])

export default __exports__